/* Alphabet search*/
export const ROUTE_BRAND = "/brand/[...all]";
export const ROUTE_BRANDS = "/brands";
export const ROUTE_BRANDS_LETTER = "/brands/letter/[letter]";
export const ROUTE_BRANDS_ENG_LETTER = "/brands/eng/[letter]";
export const ROUTE_DRUGS = "/drugs";
export const ROUTE_DRUGS_LETTER = "/drugs/letter/[letter]";
export const ROUTE_DISEASES = "/diseases";
export const ROUTE_DISEASES_LETTER = "/diseases/letter/[letter]";

/* Cart & Checkout */
export const ROUTE_CART = "/cart";
export const ROUTE_CART_DELIVERY = "/cart/delivery";
export const ROUTE_CART_PICKUP = "/cart/pickup";
export const ROUTE_CART_PAY = "/cart/pay/[orderId]";
export const ROUTE_CHECKOUT = "/checkout";
export const ROUTE_CHECKOUT_SUCCESS = "/checkout/success/[id]";
export const ROUTE_CHECKOUT_FAIL = "/checkout/fail/[id]";

/* Catalog */
export const ROUTE_CATALOG = "/catalog/[...category]";
export const ROUTE_CATEGORY = "/category/[category]";
export const ROUTE_CATEGORY_FILTERS = "/category/[category]/[filters]";
export const ROUTE_DISCOUNTS = "/discounts";
export const ROUTE_DISCOUNTS_FILTERS = "/discounts/[filters]";
export const ROUTE_GROUP = "/group/[category]";
export const ROUTE_GROUP_FILTERS = "/group/[category]/[filters]";
export const ROUTE_PROMO_PAGE = "/promo/[alias]";
export const ROUTE_INFO_EMIAS = "/info-emias";
export const ROUTE_SEARCH = "/search";
export const ROUTE_SEARCH_FILTERS = "/search/filters/[filters]";
export const ROUTE_PROCESSING_OF_PERSONAL_DATA =
  "/soglasie-na-obrabotku-personalnyh-dannyh";

/* Product */
export const ROUTE_PRODUCT = "/product/[product]";

/* Profile */
export const ROUTE_PROFILE = "/personal";

/* Information */
export const ROUTE_INFORMATION = "/information";
export const ROUTE_WORKING_RULES = "/working-rules";
export const ROUTE_INFORMATION_LICENSE = "/information/license-dostavka";
export const ROUTE_GUARANTIES = "/garantii";
export const ROUTE_EDITORIAL_POLICY = "/redakcionnaja-politika";
export const ROUTE_INSTRUCTION = "/instruction";
export const ROUTE_TERMS = "/terms";
export const ROUTE_MARKETING_POLICY = "/marketing-policy";
export const ROUTE_PHARMACIES = "/pharmacies";
export const ROUTE_PHARMACY = "/pharmacies/pharmacy/[id]";
export const ROUTE_PRESCRIPTION = "/prescription";
export const ROUTE_ABOUT = "/about";
export const ROUTE_TEAM = "/team";
export const ROUTE_TERM_OF_USE = "/termsuser";
export const ROUTE_TEAM_STAFF = "/team/staff/[id]";
export const ROUTE_TEAM_DOCTOR = "/team/doctor/[id]";
export const ROUTE_TEAM_AUTHOR = "/team/author/[id]";
export const ROUTE_SITE_RULES = "/site_rules";
export const ROUTE_ZC_PLUS = "/zdravcityplus";
export const ROUTE_ZC_PLUS_TERMS = "/zdravcityplus_terms";
export const ROUTE_ZC_PLUS_API = "/zdravcityplus_api";
export const ROUTE_ISG = "/istekayushchiy_srok_godnosti";
export const ROUTE_PROMOS = "/promo";

/* Utilities */
export const ROUTE_ORDER_BY_PHONE = "/zakazat-lekarstva-po-telefonu";
export const ROUTE_PROMO_CODE = "/promokod";
